import React, { memo } from 'react';
import { Input } from 'js/components/common/Fields/Input';

import * as Types from './types';

export const NationalIdFieldBare: React.FC<Types.INationalIdFieldConfig> = ({
    id,
    name,
    label,
    validate,
    disabled,
    readOnly,
    className,
    ariaLabel,
    inputMode,
    placeholder,
    infoTooltip,
    isLabelAsteriskEnabled,
    isPlaceholderAsteriskEnabled
}) => (
    <Input
        id={id}
        name={name}
        type="text"
        label={label}
        disabled={disabled}
        className={className}
        aria-label={ariaLabel}
        placeholder={placeholder}
        infoTooltip={infoTooltip}
        isLabelAsteriskEnabled={isLabelAsteriskEnabled}
        isPlaceholderAsteriskEnabled={isPlaceholderAsteriskEnabled}
        {...readOnly && { readOnly: true }}
        {...inputMode && { inputMode }}
        {...validate && { validate }}
    />
);

export const NationalIdField = memo(NationalIdFieldBare);
